import React from "react"

function TileLabel({ label }) {
  return <p className="title is-6 has-text-grey">{label}</p>
}

export default TileLabel
